/** 移動端全局頭部 MHeader — 繁體（t('mHeader.xxx')） */
export default {
	nav: {
		home: "首頁",
		square: "媒體廣場",
		tutor: "導師服務",
		serviceInstitution: "服務機構",
		about: "關於我們",
	},
	drawer: {
		userCenter: "個人中心",
		loginRegister: "登入/註冊",
		downloadApp: "下載App",
		languageSwitch: "繁英切換",
		contactCs: "聯係客服",
		mentorJoin: "導師入駐",
		institutionJoin: "機構入駐",
		languageRow: "語言",
		targetEn: "EN",
		targetZh: "繁",
		ariaSwitchToEn: "切換為英文",
		ariaSwitchToZh: "切換為繁體中文",
	},
	interest: {
		title: "比較喜歡什麼內容?",
		subtitle: "選擇感興趣的主題，幫你找到喜歡的內容",
		loading: "加載中...",
		submit: "完成（已選 {count} 個）",
	},
	navdown: {
		title: "下載先知命局App",
		desc: "先知命局，陪你找到人生方向",
		download: "下載",
		closeAria: "關閉下載提示",
	},
};
